var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.products)?_c('product-list',{attrs:{"products":_vm.productList.data}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }